import { EditButton, Drawer, Form, Input, Button, Grid, notification } from '@pankod/refine-antd';
import { useState, Dispatch, SetStateAction } from 'react';
import { IPaymentMethod } from 'interfaces';
import { getPaymentMethods, updatePaymentMethod } from 'services/payment';

type EditPaymentMethodProps = {
  resource: 'client' | 'supplier' | 'company';
  resourceId: string;
  paymentMethod: IPaymentMethod;
  setPaymentMethods: Dispatch<SetStateAction<IPaymentMethod[]>>;
};

export const EditPaymentMethod: React.FC<EditPaymentMethodProps> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);
  const breakpoint = Grid.useBreakpoint();

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const onFinish = async (values: any) => {
    try {
      await updatePaymentMethod(props.resource, props.paymentMethod.id, values);
      const paymentMethods = await getPaymentMethods(props.resource, props.resourceId);
      props.setPaymentMethods(paymentMethods);
      notification.success({
        message: 'Success',
        description: 'Successfully updated payment method.',
      });
      closeDrawer();
    } catch (err) {
      return notification.error({
        message: 'Failed',
        description: 'Failed to update.',
      });
    }
  };

  return (
    <div>
      {!visible && <EditButton size="small" hideText onClick={showDrawer} />}
      <Drawer
        title="Edit Payment Method"
        placement="right"
        width={breakpoint.sm ? '450px' : '100%'}
        visible={visible}
        onClose={closeDrawer}
      >
        <Form
          layout="vertical"
          initialValues={{
            ...props.paymentMethod,
          }}
          onFinish={onFinish}
        >
          <Form.Item label="Account Name" name="accountName">
            <Input />
          </Form.Item>
          <Form.Item label="Account Number" name="accountNumber">
            <Input />
          </Form.Item>
          <Form.Item
            label="Bank Name"
            name="bankName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Branch Name" name="branchName">
            <Input />
          </Form.Item>
          <Form.Item label="Swift Code" name="swiftCode">
            <Input />
          </Form.Item>
          <Form.Item wrapperCol={{ span: 4, offset: 20 }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};
